import { render, staticRenderFns } from "./ItemClassSelect.vue?vue&type=template&id=a8eef6b6"
import script from "./ItemClassSelect.vue?vue&type=script&lang=js"
export * from "./ItemClassSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports